import React, { useState } from 'react'

export default function Nav() {
  var [nav, setNav] = useState(false);

  return (
      <>
      <nav className={nav ? "my-nav active" : "my-nav"}>
        <ul>
          <li><a href="/" className="primary"><div className="icon"><i className="fal fa-home"></i></div> Home</a></li>
          <li><a href="/"><div className="icon"> <i className="fal fa-user"></i> </div> Profile</a></li>
          <li><a href="/"><div className="icon"> <i className="fal fa-plus"></i> </div> New</a></li>
          <hr/>
          <li><a href="/"><div className="icon"> <span className="circle">3</span> <i className="fal fa-bell"></i> </div> Notifications</a></li>
          <li><a href="/"><div className="icon"> <i className="fal fa-question"></i> </div> Support</a></li>
          <li><a href="/"><div className="icon"> <i className="fal fa-cog"></i> </div> Settings</a></li>
        </ul>
      </nav>

      <div className={nav ? "icon navbtn active" : "icon navbtn"} onClick={e => setNav(!nav)}><i class={nav ? "fal fa-times" : "fal fa-bars"}></i></div>
      </>

  )
}
